/**
 * Frontend Javascript
 */

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';


/**
 * DOM Ready
 */
jQuery(document).ready(function($) {

    // Initialize LMPS plugin on body
	$( 'body' ).lmps();

});


/**
 * Plugin LMPS
 */
;(function ( $, window, document, undefined ) {

	// Create the defaults
	let pluginName = 'lmps';

	// The actual plugin constructor
	function Plugin( element, options ) {

		// Set main vars
		this._name = pluginName;
		this.el = $( element );
        this.psObj = null;
		this.listSlides = [];
		
		// Init
		this.init();

	}

	/**
	 * Init
	 */
	Plugin.prototype.init = function () {

		// Build list of slides
		this.getSlides();

        // Init PhotoSwipe
        this.initPhotoswipe();

		// Click on an linked image
		this.onThumbClick();

	};

    /**
	 * Init PhotoSwipe
	 */
	Plugin.prototype.initPhotoswipe = function () {

        this.psObj = new PhotoSwipeLightbox({
            dataSource: this.listSlides,
            closeTitle: 'Fermer',
            zoomTitle: 'Zoom',
            arrowPrevTitle: 'Précédente',
            arrowNextTitle: 'Suivante',
            pswpModule: () => import('photoswipe')
        });

    };

	/**
	 * Build array of slides
	 */
	Plugin.prototype.getSlides = function () {
		let _this = this;

		// Loop through linked images
		this.el.find( 'a[data-pswp-width]:has(img)' ).each(function(index, el) {
			let curLink = $( this );
			let imgWidth = curLink.data( 'pswp-width' );
            let imgHeight = curLink.data( 'pswp-height' );

			// Add index info to link
			curLink.data( 'lmps-slide-id', index );

			// Add item to slides list
			_this.listSlides.push(
				{
					src: curLink.attr( 'href' ),
					width: imgWidth,
                    height: imgHeight,
				}
			);

		});

	};

	/**
	 * On click on linked image
	 */
	Plugin.prototype.onThumbClick = function() {
		let _this = this;

		this.el.on( 'click', 'a[data-pswp-width]:has(img)', function(e){
			e.preventDefault();

			// Get image index
			let imgIndex = $( this ).data( 'lmps-slide-id' );

			// Load and open PhotoSwipe
			_this.psObj.loadAndOpen(imgIndex);
 
		});

	};

	/**
	 * Prevent multiple plugin instantiations on the same element
	 * @param  {object} 		options 	Options passed to the plugin
	 * @return {jQuery Object}         		Element with plugin instance attached to it
	 */
    $.fn[pluginName] = function ( options ) {
        return this.each( function () {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    }

})( jQuery, window, document );